$mol_svg_circle $mol_svg
	dom_name \circle
	pos /
	attr *
		^
		r <= radius \.5%
		cx <= pos_x \
		cy <= pos_y \
